@use '../../../../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../../../../styles/Constants.scss' as Constants;

.modal-footer-override {
	:global(.modal-footer) {
		z-index: 0 !important;
	}
}

.editable-notice {
	font-style: italic;
	color: Colors.$col-design-gray5;
	margin-bottom: Constants.$val-spacing-m;
}

.group-option {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	padding: Constants.$val-spacing-xs;
	gap: Constants.$val-spacing-xs;
}

@mixin readonly-cell-content {
	padding: 0.375rem 0.75rem;
	line-height: 1.5;
	color: Colors.$col-blackDark;
	flex: 1;

	display: flex;
	align-items: center;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	background-color: Colors.$col-white;
	width: 100%;
	height: 100%;
}

.readonly-cell {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-xs;
	padding: Constants.$val-spacing-xs;
	background-color: Colors.$col-white;
	width: 100%;
	height: 100%;

	&--text,
	&--numeric,
	&--quantity,
	&--dollar {
		@include readonly-cell-content;
	}

	&--numeric {
		text-align: start;
	}

	&--quantity,
	&--dollar {
		text-align: end;
		justify-content: flex-end;
	}

	&--archived {
		color: Colors.$col-design-grey400 !important;
		background-color: Colors.$col-greyBackgorund2 !important;
		width: 100%;
	}

	&--clickable {
		cursor: pointer;
	}
}

.info-icon {
	font-size: Constants.$val-fontSizeBig;
	cursor: pointer;
	color: Colors.$col-design-blue500;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding-left: Constants.$val-spacing-s;
}

.bold {
	font-weight: bold;
}

.modal-intro-text {
	font-weight: bold;
	font-size: Constants.$val-fontSizeBig;
	line-height: Constants.$val-lineHeightBig;
	padding-bottom: Constants.$val-spacing-m;
}

.modal-billing-code-container {
	padding-bottom: Constants.$val-spacing-m;
}

.billing-code-description {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-xs;
}

.radio-label {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-xs;
	cursor: pointer;
	justify-content: flex-start;
	align-items: center;
	padding-bottom: Constants.$val-spacing-m;

	&__input {
		cursor: pointer;
		margin-bottom: Constants.$val-spacing-m !important;
		padding: Constants.$val-spacing-m !important;

		&::before {
			cursor: pointer;
			left: Constants.$val-spacing-l !important;
		}
	}
}

.archive-modal-question {
	padding-bottom: Constants.$val-spacing-m;
}

.archive-modal-warning-text {
	padding-top: Constants.$val-spacing-s;
}
